<script setup>
    import { defineProps, reactive } from 'vue';
    defineProps({
        navigate: {
            type: Function,
            required: true
        }
    });

   const services = [
      { icon: 'document-text-outline', title: 'Visa Application Assistance', description: 'We help you with student visa applications, document preparation process, and interview.' },
      { icon: 'globe-outline', title: 'Permanent Residency Guidance', description: 'Learn about the pathways to residency for international students and graduates.' },
      { icon: 'map-outline', title: 'vacation Planning', description: 'Leave the hassles of booking rides, tickets and hotels to us, and enjoy what our vaction packages have to offer.' },
  ]
    const steps = [
       { number: 1, title: 'Consultation', description: 'Schedule a one on one session with our experts to discuss your goals and options.' },
       { number: 2, title: 'Application', description: 'We guide you through the entire application process, ensuring accuracy.' },
       { number: 3, title: 'Approval', description: 'Receive your visa and get ready for your study abroad journey!' },
    ]

    const faqs = reactive([
                        
                        { question: 'What are the typical visa processing times?', answer: 'Processing times vary greatly depending on the country and current volume. Our advisors provide the latest estimates during consultation.', open: false },
                        { question: 'What are the most common challenges in the application process?', answer: 'Common challenges include documentation errors, proving financial stability, and interview preparation. We specialize in mitigating these risks.', open: false },
                        { question: 'Why should I use Swif Study Abroad\'s services?', answer: 'We offer personalized, expert guidance with a high success rate, saving you time and stress by managing the entire complex process.', open: false },
                        { question: 'How much do your services cost, and do you offer payment plans?', answer: 'We operate on a payment after service model, ensuring you only pay once your objectives are met. Flexible payment plans can also be arranged to suit your needs.', open: false },
                    ])

</script>

<template>

  <div>
  <div>
     <!-- 1. Hero Section -->
      <section class="relative h-[50vh] sm:h-[60vh] md:h-[80vh] overflow-hidden" id="Hero">
          <div class="absolute inset-0 hero-bg animate-kenburns"></div>
          <div class="absolute inset-0 bg-gray-900 bg-opacity-50"></div>
          <div class="container mx-auto px-4 flex items-center h-full relative z-10 text-white">
              <div class="w-full max-w-xl text-center md:text-left px-4">
                  <h1 class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4 leading-tight animate-fade-in-up" >
                      Navigate Your Journey to a New Country with Ease.
                  </h1>
                  <p class="text-base sm:text-lg mb-6 animate-fade-in-up [animation-delay:150ms]">Connecting dreams to destinations</p>
                  <button @click="navigate('contact-us')" class="bg-red-600 text-white font-medium py-2 px-4 rounded hover:bg-blue-700 transition hover:scale-105 animate-fade-in-up [animation-delay:300ms]">
                    Contact Us  
                    <ion-icon style="margin-left: 10px;" name="call"></ion-icon>
                  </button>
              </div>
          </div>
        </section>
  </div>

  <div>
    <!-- 2. Immigration Services -->
    <section class="bg-white py-16" id="services">
        <div class="container mx-auto px-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
                <div v-for="(service, index) in services" :key="service.title" v-reveal:up="index * 100" class="p-4 sm:p-6 text-center border border-gray-100 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 transition duration-300">
                    <div class="flex justify-center mb-4">
                        <div class="bg-pink-50 p-3 sm:p-4 rounded-full inline-block">
                            <ion-icon :name="service.icon" class="w-8 h-8 text-primary"></ion-icon>
                        </div>
                    </div>
                    <h3 class="font-bold text-xl text-gray-800 mb-3">{{ service.title }}</h3>
                    <p class="text-gray-600 text-sm">{{ service.description }}</p>
                </div>
            </div>
        </div>
    </section>
  </div>

<div> 
   <section class="bg-gray-50 py-16">
      <div class="container mx-auto px-4">
          <h2 class="text-3xl font-bold text-gray-800 text-center mb-16"> How It Works </h2>
          <div class="flex flex-col md:flex-row justify-center items-center space-y-10 md:space-y-0 md:space-x-4 lg:space-x-8 xl:space-x-12 relative">
              <!-- Horizontal Line for Desktop -->
              <div class="hidden md:block absolute top-8 w-4/5 h-0.5 bg-gray-300" v-reveal:none></div>

              <div v-for="(step, index) in steps" :key="step.number" v-reveal:up="index * 150" class="text-center w-full sm:w-4/5 md:w-1/3 relative">
                  <div class="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary text-white font-extrabold text-xl sm:text-2xl shadow-md border-4 border-white">
                      {{ step.number }}
                  </div>
                  <h3 class="font-bold text-xl text-gray-800 mb-2">{{ step.title }}</h3>
                  <p class="text-gray-600">{{ step.description }}</p>
              </div>
          </div>
      </div>
  </section>
</div>
  <!-- Client Trust -->
  <main class="container mx-auto px-4 py-16">
      <div class="flex flex-col md:flex-row items-center gap-8 md:gap-12 mb-12">
          <div class="md:w-1/2 text-center md:text-left" v-reveal:right>
              <h1 class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-800 mb-3">Why Trust Us?</h1>
              <p class="text-gray-600 text-sm sm:text-base max-w-2xl md:max-w-none mx-auto md:mx-0">Swif Study Abroad Consultancy is your premier, Canada-based destination for turning global aspirations into reality. Active for over half a decade, we've successfully served thousands of clients with unique needs. While renowned for offering the best Canadian study visa services and genuine immigration advice, our expertise extends seamlessly across all of North America and key regions of Europe. Unlike other firms, we also curate exclusive, hassle-free vacation packages alongside our study placements, ensuring that whether you need a long-term student visa or a bespoke travel experience, your journey is managed with expert strategy. We are the experienced partner ready to help you Say Home in your dream destination.</p>
          </div>
          <div id="dazzle-image" class="md:w-1/2 flex justify-center relative" v-reveal:left>
              <img src="@/assets/images/trust_couple_2.jpeg" class="rounded-full shadow-lg w-full max-w-md aspect-square object-cover transition-transform duration-500 hover:scale-105 dazzle-image animate-float">
          </div>
      </div>
  </main>

  <!-- FAQ Section -->
  <section class="bg-white py-16">
      <div class="container mx-auto px-4">
          <h2 class="text-3xl font-bold text-gray-800 text-center md:text-left mb-10">Frequently Asked Questions</h2>
          <div class="max-w-3xl mx-auto md:mx-0">
              <div v-for="(faq, index) in faqs" :key="index" class="border-b border-gray-200 py-4">
                  <button @click="faq.open = !faq.open" class="flex justify-between items-center w-full text-left focus:outline-none">
                      <h3 class="text-lg font-semibold text-gray-800">{{ faq.question }}</h3>
                      <ion-icon :name="faq.open ? 'chevron-up-outline' : 'chevron-down-outline'" class="text-gray-500 w-5 h-5"></ion-icon>
                  </button>
                  <transition name="faq">
                      <div v-show="faq.open" class="mt-2 text-gray-600 overflow-hidden">
                          <p>{{ faq.answer }}</p>
                      </div>
                  </transition>
              </div>
          </div>
      </div>
  </section>
  <!-- Call to Action Section -->
  <section class="bg-pink-50 py-16">
      <div class="container mx-auto px-4 text-center">
          <h2 class="text-3xl font-bold text-gray-800 mb-4">Ready to Start Your Journey?</h2>
          <p class="text-gray-600 max-w-2xl mx-auto mb-8">
              Let us handle the complexities of immigration so you can focus on your future. Book a free
              consultation with our expert advisors today.
          </p>
          <button  @click="navigate('scheduling')"  class="bg-red-600 text-white font-medium py-3 px-8 rounded-lg shadow-lg hover:bg-red-700 hover:scale-105 transition duration-300 animate-glow">
              Schedule a Consultation Now
          </button>
      </div>
  </section>
  </div>
</template>

<style scoped>
@media (max-width: 640px) {
  #services, section.bg-gray-50 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}

  #Hero {
    background-image: url('../assets/images/tower.jpg');
    background-size: cover;
    background-position: center;
  }

  .hero-bg {
    background-image: url('../assets/images/tower.jpg');
    background-size: cover;
    background-position: center;
    transform-origin: center;
  }

  .faq-enter-active,
  .faq-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
  }
  .faq-enter-from,
  .faq-leave-to {
    opacity: 0;
    transform: translateY(-6px);
  }

  @media (prefers-reduced-motion: reduce) {
    .animate-kenburns,
    .animate-float,
    .animate-glow {
      animation: none !important;
    }
  }
 


</style>

